// Listado de razas de perros más comunes en España
export const DOG_BREEDS = [
  'Mestizo / Cruce',
  'No lo sé',
  'Affenpinscher',
  'Akita',
  'Alaskan Malamute',
  'Basset Hound',
  'Beagle',
  'Bichón Frisé',
  'Bichón Maltés',
  'Bodeguero Andaluz',
  'Border Collie',
  'Boston Terrier',
  'Boxer',
  'Boyero de Berna',
  'Braco Alemán',
  'Braco de Weimar',
  'Bull Terrier',
  'Bulldog Francés',
  'Bulldog Inglés',
  'Bullmastiff',
  'Cane Corso',
  'Caniche / Poodle',
  'Carlino / Pug',
  'Cavalier King Charles',
  'Chihuahua',
  'Chow Chow',
  'Cocker Spaniel',
  'Collie',
  'Dálmata',
  'Dobermann',
  'Dogo Argentino',
  'Dogo de Burdeos',
  'Fox Terrier',
  'Galgo Español',
  'Golden Retriever',
  'Gran Danés',
  'Husky Siberiano',
  'Jack Russell Terrier',
  'Labrador Retriever',
  'Lebrel Afgano',
  'Mastín Español',
  'Mastín Napolitano',
  'Pastor Alemán',
  'Pastor Australiano',
  'Pastor Belga Malinois',
  'Pastor de los Pirineos',
  'Pequinés',
  'Perro de Agua Español',
  'Pitbull / American Bully',
  'Podenco',
  'Pomerania',
  'Ratonero Bodeguero',
  'Rottweiler',
  'Samoyedo',
  'San Bernardo',
  'Schnauzer',
  'Setter Inglés',
  'Shar Pei',
  'Shiba Inu',
  'Shih Tzu',
  'Springer Spaniel',
  'Staffordshire Bull Terrier',
  'Teckel / Salchicha',
  'Terranova',
  'Terrier Escocés',
  'West Highland White Terrier',
  'Whippet',
  'Yorkshire Terrier',
];
